import React, { useCallback } from 'react';
import { ButtonOrange } from 'components/button-orange';
import AddIcon from '@mui/icons-material/Add';
import { useOpen } from 'AurionCR/components/hooks';
import {
  DialogTaskCreate,
  ResultCreate,
  useTodoTaskNotificationCreated,
} from 'components/dialog-task';
import { emitterLayoutContent } from '../../helpers';
import { useTranslate } from 'hooks/use-translate';
import { useIsBelowMd } from 'hooks/use-is-below-md';

interface Props {}

export const ButtonTask: React.FC<React.PropsWithChildren<Props>> = () => {
  const { t } = useTranslate();
  const { isOpen, handleToggle, handleClose } = useOpen();
  // Phase F1 (Task 6): the header has no room for the label below md; the icon keeps the title.
  const isBelowMd = useIsBelowMd();

  const { onSend } = useTodoTaskNotificationCreated();
  const onCreated = useCallback(
    async (data: ResultCreate, shouldContinue: boolean) => {
      emitterLayoutContent.emit('task-created', data);

      const taskID = String(data.id);

      if (!shouldContinue) {
        handleClose();
      }

      await onSend({ id: taskID });
    },
    [handleClose, onSend],
  );

  return (
    <>
      {isBelowMd ? (
        <ButtonOrange
          className="button-add-task"
          onClick={handleToggle}
          title={t('add-task')}
          aria-label={t('add-task')}
        >
          <AddIcon />
        </ButtonOrange>
      ) : (
        <ButtonOrange className="button-add-task" onClick={handleToggle} startIcon={<AddIcon />}>
          {t('add-task')}
        </ButtonOrange>
      )}

      {isOpen && <DialogTaskCreate onClose={handleClose} onCreated={onCreated} />}
    </>
  );
};
